<div class="banner-wrapper">
  <div class="banner-container">
    <ul class="banner-content">
      <li class="banner-item logo" lang="fr">
        <a href="https://www.quebec.ca/" target="_blank">
          <img
            id=""
            alt="Site Web Société québécoise des infrastructures."
            src="assets/images/signature-PIV.svg"
        /></a>
      </li>
      <li class="banner-item title">
        <a href="https://www.sqi.gouv.qc.ca/"
          ><span>Société québécoise des infrastructures</span></a
        >
      </li>
      <li class="banner-item">
        <a id="toggle-button" class="loop">
          <span
            ><img
              alt="Recherche"
              src="assets/images/loop.svg"
              width="24"
              height="24" /></span
        ></a>
      </li>
      <li class="banner-item">
        <a class="wt" href="https://www.sqi.gouv.qc.ca/a-propos/nous-joindre"
          >Nous joindre</a
        >
      </li>
    </ul>
  </div>
</div>
